import { Controller } from "@hotwired/stimulus"
import confetti from "canvas-confetti"

export default class extends Controller {
  connect() {
    this.fire()
  }

  fire() {
    const colors = ["#ea4335", "#fbbc04", "#4285f4", "#34a853", "#ff6d01", "#ab47bc"]
    const defaults = { colors, spread: 100, ticks: 100, gravity: 0.8, scalar: 1.3, disableForReducedMotion: true }

    // Burst 1 — center explosion
    confetti({ ...defaults, particleCount: 50, origin: { x: 0.5, y: 0.4 } })

    // Burst 2 — left cannon
    setTimeout(() => {
      confetti({ ...defaults, particleCount: 35, angle: 60, origin: { x: 0.2, y: 0.6 } })
    }, 150)

    // Burst 3 — right cannon
    setTimeout(() => {
      confetti({ ...defaults, particleCount: 35, angle: 120, origin: { x: 0.8, y: 0.6 } })
    }, 300)

    // Clean up trigger element
    setTimeout(() => this.element.remove(), 3000)
  }
}
